(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('[data-accelerated-checkout-text]');
    if (!containers.length) return;

    for (const container of containers) {
      const customText = container.getAttribute('data-accelerated-checkout-text');
      if (!customText) continue;

      const applyText = () => {
        const button = container.querySelector('.shopify-payment-button__button');
        if (!button) return;

        button.textContent = customText;
      };

      applyText();

      const observer = new MutationObserver(() => {
        applyText();
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jv-product-description-excerpt"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.jvProductDescExcerptInited) return;
    window.jvProductDescExcerptInited = true;

    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-jv-desc-excerpt-link]');
      if (!link) return;

      event.preventDefault();

      const tabs = document.querySelector('.jv-product-tabs');
      if (tabs) {
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const descriptionSection = document.querySelector('[data-product-description], .product-description, #product-description');
      if (descriptionSection) {
        descriptionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
